import React from "react";

const Supplementary = () => {
  return <section className="my-3">Supplementary</section>;
};

export default Supplementary;
